import type { BoxId } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface UnhighlightBoxCommand {
  boxId: BoxId;
}

export const unhighlightBox: GraphCommandFactory<UnhighlightBoxCommand> =
  (cmdContext) => (command) => {
    cmdContext.eventEmitter.emit('unhighlightBox', { boxId: command.boxId });
  };
